import { ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SliderCounter.css';

interface ISliderCounterProps {
  current: number;
  total: number;
}

export const SliderCounter: React.FC<ISliderCounterProps> = ({ current, total }) => {
  return (
    <div className={styles['counter']}>
      <ArticleParagraph1>
        {current}/{total}
      </ArticleParagraph1>
    </div>
  );
};
